import { render } from "./ListCart.vue?vue&type=template&id=c480d036"
import script from "./ListCart.vue?vue&type=script&lang=js"
export * from "./ListCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__